<template>
    <div class="main">
		<!-- Super Navbar -->
		<super-nav-inventro v-if="isNavVisible"/>

		<main class="main">
			<!-- Billings Notice -->
			<div class="container" v-if="billingsCount > 0 && billingsNoticeVisible">
				<div class="alert alert-danger has-shadow flex-center mt-3">
					<span
						>Anda memiliki {{ billingsCount }} tagihan yang menunggu untuk
						dibayarkan</span
					>
					<router-link class="ml-auto btn btn-primary" to="/billings">
						Lihat Tagihan
					</router-link>
				</div>
			</div>

			<!-- Limited Stock Notice -->
			<div class="container" v-if="limitedStockProductIds.length > 0 && limitedStockNoticeVisible">
				<div class="alert alert-danger has-shadow flex-center mt-3">
					<span
						>Anda memiliki {{ limitedStockProductIds.length }} produk yang memiliki stock kurang dari atau sama dengan 10</span
					>
					<button class="ml-auto btn btn-primary" @click="goToLimitedStockProducts">
						Lihat Produk
					</button>
				</div>
			</div>

			<!-- Cancelled Submission Notice -->
			<div class="container" v-if="cancelledSubmissionIds.length > 0 && cancelledSubmissionNoticeVisible">
				<div class="alert alert-danger has-shadow flex-center mt-3">
					<span
						>Anda memiliki {{ cancelledSubmissionIds.length }} Order yang dibatalkan</span
					>
					<button class="ml-auto btn btn-primary" @click="goToCancelledSubmission">
						Lihat Order
					</button>
				</div>
			</div>

			<!-- Empty Password Notice -->
			<div class="container" v-if="isPasswordEmpty && emptyPasswordNoticeVisible">
				<div class="alert alert-danger has-shadow flex-center mt-3">
					<span
						>Anda belum mengatur password. Harap masukkan password di halaman profile.</span
					>
					<router-link class="ml-auto btn btn-primary" to="/profile">
						Lihat Profile
					</router-link>
				</div>
			</div>

			<!-- Empty Address Notice -->
			<div class="container" v-if="!isHasStoreAddress && emptyAddressNoticeVisible">
				<div class="alert alert-warning has-shadow flex-center mt-3">
					<span
						>Anda belum mengatur alamat. Harap masukkan alamat di halaman profile.</span
					>
					<router-link class="ml-auto btn btn-primary" to="/profile?tab=address">
						Lihat Profile
					</router-link>
				</div>
			</div>

			<router-view v-if="isNotAuthorizedPage || !!user"></router-view>

			<div class="page-loader mt-5" v-else>
				<div class="is-loading dark large"></div>
			</div>
			<announcements
				:visible="isRightbarVisible"
				@close="toggleAnnouncements(false)"
				v-if="isRightbarVisible"
			>
			</announcements>
		</main>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import submissionApi from '@/api/submissions';
import Announcements from '@/components/Announcements.vue';

const SuperNavInventro = () => import(
	/* webpackChunkName: "super-nav-ostock" */ '@/components/inventro/SuperNavInventro.vue'
);

export default {
	name: 'MainLayout',
	components: {
		Announcements,
		SuperNavInventro,
	},
	computed: {
		...mapGetters({
			user: 'user',
			isOwner: 'isOwner',
			settings: 'settings',
			isLoggedIn: 'isLoggedIn',
			isSupplier: 'isSupplier',
			isDropshipper: 'isDropshipper',
			isRoleAdmin: 'isRoleAdmin',
			isHasUsername: 'isHasUsername',
			isHasBankAccounts: 'isHasBankAccounts',
			isRightbarVisible: 'isRightbarVisible',
			notice: 'notice',
			billingsCount: 'billingsCount',
			billingsDueCount: 'billingsDueCount',
			limitedStockProductIds: 'limitedStockProductIds',
			cancelledSubmissionIds: 'cancelledSubmissionIds',
			isPasswordEmpty: 'isPasswordEmpty',
			isHasStoreAddress: 'isHasStoreAddress',
			isExpired: 'isExpired',
			isAdmin: 'isAdmin',
			appName: 'appName',
			appProject: 'appProject',
		}),
		isNotAuthorizedPage() {
			const routePath = this.$route.path;
			const routeName = this.$route.name;
			const isHome = routePath === '/';
			const isLogin = routePath === '/login' || routePath === '/admin/login';
			const isRegister = (routePath === '/register' || routePath === '/register/supplier');
			const isSearch = routePath === '/search';
			const isPages = routePath.includes('/page');
			const isIndex = routePath === '/index.html';
			const isResetPassword = routePath === '/password/reset';
			const isAuthCallback = routePath === '/auth/callback';
			const isBillingRedirect = routePath === '/billings-redirect';
			const isProductDetail = routeName === 'product-detail';
			const isBrand = routePath === '/brand';
			const isDirect = routePath === '/direct';
			const isSupplierProducts = routePath.includes('/supplier');
			const isAllowed = isHome || isIndex || isLogin
							|| isResetPassword || isSearch || isRegister
							|| isAuthCallback || isPages || isBillingRedirect
							|| isProductDetail || isBrand || isDirect
							|| isSupplierProducts;
			return isAllowed;
		},
		isNavVisible() {
			return !this.isAdminArea && this.$route.path.indexOf('/auth/callback') === -1;
		},
		isRoutePageEditor() {
			return this.$route.name !== 'PageEditor';
		},
		billingsNoticeVisible() {
			return this.isRoutePageEditor;
		},
		limitedStockNoticeVisible() {
			return this.isRoutePageEditor;
		},
		emptyPasswordNoticeVisible() {
			return this.isRoutePageEditor;
		},
		cancelledSubmissionNoticeVisible() {
			return this.isRoutePageEditor;
		},
		emptyAddressNoticeVisible() {
			return this.isDropshipper && this.isRoutePageEditor;
		},
		isAdminArea() {
			return this.$route.path.includes('admin');
		},
	},
	methods: {
		...mapActions({
			toggleAnnouncements: 'toggleAnnouncements',
			setCancelledSubmissionIds: 'setCancelledSubmissionIds',
		}),
		goToLimitedStockProducts() {
			const productIdsString = this.limitedStockProductIds.join();
			this.$router.push(`/products?product_ids=${productIdsString}`);
		},
		goToCancelledSubmission() {
			const callback = () => {
				this.setCancelledSubmissionIds([]);
			};
			const callbackError = (error) => {
				console.log(error);
				this.$notify({
					group: 'app',
					title: 'Submission',
					text: 'Set Cancel Submission Readed',
					type: 'warn',
				});
			};
			submissionApi.cancelledNoticeReaded(callback, callbackError);
			const productIdsString = this.cancelledSubmissionIds.join();
			this.$router.push(`/orders?submission_ids=${productIdsString}`);
		},
	},
	watch: {
		user() {
			const slugExist = this.$route.params?.slug ?? null;
			if (this.isAdmin && slugExist !== null) {
				this.$router.push(`/admin/products/preview/${slugExist}`);
			} else if (this.isAdmin && !this.isSupplier && !this.isDropshipper) {
				this.$router.push('/admin');
			}
		},
	},
};
</script>
